import React from 'react';
import { Box, Typography } from '@mui/material';
import { tint } from '../../theme';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  /** Render inside a table cell, where the surrounding card already pads. */
  dense?: boolean;
}

/** Shown instead of a blank panel when a query legitimately returns nothing. */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  dense = false,
}) => (
  <Box
    sx={{
      textAlign: 'center',
      py: dense ? 4 : 7,
      px: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1,
    }}
  >
    <Box
      aria-hidden="true"
      sx={{
        display: 'grid',
        placeItems: 'center',
        width: 48,
        height: 48,
        borderRadius: 2.5,
        mb: 0.5,
        color: 'text.secondary',
        bgcolor: (theme) => tint(theme, 'text.primary', 0.05),
        '& svg': { fontSize: 24 },
      }}
    >
      {icon ?? <InboxOutlinedIcon />}
    </Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: '46ch' }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 1.5 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
